import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../../common/constants';

import type { SchedulesResponse } from './types';

export const getSchedulesEndpoint = () => {
	return fetch<SchedulesResponse>(`${urls.schedules.onCalls.url()}`);
};
